var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttempt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_927",
    "data-name": "Path 927"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.2,90.18A13.2,13.2,0,0,1,1,77V23A13.21,13.21,0,0,1,14.2,9.82H40a13.14,13.14,0,0,1,9.19,3.72l6.12,5.93a7.19,7.19,0,0,0,5,2H85.8A13.22,13.22,0,0,1,99,34.72V77a13.21,13.21,0,0,1-13.2,13.2Zm0-74.41A7.26,7.26,0,0,0,7,23V77a7.26,7.26,0,0,0,7.25,7.25H85.8A7.26,7.26,0,0,0,93.05,77V34.72a7.28,7.28,0,0,0-7.25-7.26H60.36a13.12,13.12,0,0,1-9.18-3.72l-6.12-5.93a7.26,7.26,0,0,0-5.05-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempt);
export default __webpack_public_path__ + "static/media/Attempt.695199ad561974ceda04b276a316d1a3.svg";
export { ForwardRef as ReactComponent };